import React from 'react';
import { LANGUAGES, TERMS_OF_SERVICE } from './constants';
import './tableTermsOfServices.scss';

const TableView = () => {
	return (
		<div className="tos_page_outer">
			<h5>Terms and Conditions</h5>
			<table className="tos_table">
				<thead className="table-header">
					<tr>
						<th>{TERMS_OF_SERVICE.header[LANGUAGES.english].text}</th>
						<th className="empty-header"></th>
						<th dir="rtl">{TERMS_OF_SERVICE.header[LANGUAGES.arabic].text}</th>
					</tr>
				</thead>
				<tbody className="table-body">
					{TERMS_OF_SERVICE.data.map((data, index) => {
						return (
							<tr id={index}>
								<td>{data[LANGUAGES.english].text}</td>
								<td></td>
								<td dir="rtl">{data[LANGUAGES.arabic].text}</td>
							</tr>
						);
					})}
				</tbody>
			</table>
		</div>
	);
};

export default TableView;
